export type InvoiceRoundingMethod = "none" | "nearest_0_05";

export const INVOICE_ROUNDING_OPTIONS: Array<{
  label: string;
  value: InvoiceRoundingMethod;
}> = [
  { label: "Exact cents", value: "none" },
  { label: "Nearest 5 cents", value: "nearest_0_05" },
];

export const CLIENT_ROUNDING_OPTIONS = [
  { label: "Use workspace default", value: "" },
  ...INVOICE_ROUNDING_OPTIONS,
];

export function invoiceRoundingLabel(value: InvoiceRoundingMethod | null) {
  if (value === null) return "Workspace default";
  return (
    INVOICE_ROUNDING_OPTIONS.find((option) => option.value === value)?.label ??
    "Exact cents"
  );
}
